import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { DataTransferFormState, DataTransferState } from '../types';
import { dataTransferState } from './dataTransferState';

export const dataTransferSlice = createSlice({
  name: 'dataTransfer',
  initialState: dataTransferState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDataTransferOptionType: (
      state,
      action: PayloadAction<DataTransferFormState['dataTransferOptions']>,
    ) => {
      state.formState.dataTransferOptions = action.payload;
    },
    setSubsetOptionType: (
      state,
      action: PayloadAction<DataTransferFormState['subsetOptions']>,
    ) => {
      state.formState.subsetOptions = action.payload;
    },
    setDateRange(
      state,
      action: PayloadAction<DataTransferFormState['dateRange']>,
    ) {
      state.formState.dateRange = action.payload;
    },
    setDrivers(
      state,
      action: PayloadAction<DataTransferFormState['selectedDrivers']>,
    ) {
      state.formState.selectedDrivers = action.payload;
    },
    setVehicles(
      state,
      action: PayloadAction<DataTransferFormState['selectedVehicles']>,
    ) {
      state.formState.selectedVehicles = action.payload;
    },
    setInvestigationCode(
      state,
      action: PayloadAction<DataTransferFormState['investigationCode']>,
    ) {
      state.formState.investigationCode = action.payload;
    },

    setToggleCCMTAModal(
      state,
      action: PayloadAction<DataTransferState['isToggleSubmitToCcmtaModal']>,
    ) {
      state.isToggleSubmitToCcmtaModal = action.payload;
    },

    setToggleFMCSAMessagesPopup(
      state,
      action: PayloadAction<DataTransferState['isToggleFMCSAMessagesPopup']>,
    ) {
      state.isToggleFMCSAMessagesPopup = action.payload;
    },

    setFMCSAResponse(
      state,
      action: PayloadAction<DataTransferState['FMCSAResponse']>,
    ) {
      state.FMCSAResponse = action.payload;
    },

    resetForm: state => {
      state.formState = dataTransferState.formState;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: dataTransferActions } = dataTransferSlice;

/* ------- STATE SELECTORS ------- */
export const selectDataTransfer = (state: RootState) => state.dataTransfer;

export default dataTransferSlice.reducer;
